// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.css-5wly58-MuiDataGrid-root {
    color:#fff !important
}

.DealsHeader{
    
    font-size: x-large;
}
.condtionalInfo{
    
    font-size: x-large;
    text-align: center;
}
.DealsDatagrid .css-axafay-MuiDataGrid-virtualScroller{
    max-height: 550px !important;
}
.addNewDeal button{
    width: 150px;
    height: 30px;
    background: linear-gradient(90deg, rgba(73,150,238) 0%, rgba(37,75,119) 100%);
    cursor: pointer;
    padding: 12px;
    overflow: hidden;
    margin-bottom: 10px;
    border-radius: 0 !important;
    
}

.addNewDeal button:hover{
    background: linear-gradient(90deg,rgba(37,75,119) 0%, rgba(73,150,238) 100%);
}`, "",{"version":3,"sources":["webpack://./src/pages/Deals/Deals.css"],"names":[],"mappings":";AACA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,YAAY;IACZ,6EAA6E;IAC7E,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;;AAE/B;;AAEA;IACI,4EAA4E;AAChF","sourcesContent":["\n.css-5wly58-MuiDataGrid-root {\n    color:#fff !important\n}\n\n.DealsHeader{\n    \n    font-size: x-large;\n}\n.condtionalInfo{\n    \n    font-size: x-large;\n    text-align: center;\n}\n.DealsDatagrid .css-axafay-MuiDataGrid-virtualScroller{\n    max-height: 550px !important;\n}\n.addNewDeal button{\n    width: 150px;\n    height: 30px;\n    background: linear-gradient(90deg, rgba(73,150,238) 0%, rgba(37,75,119) 100%);\n    cursor: pointer;\n    padding: 12px;\n    overflow: hidden;\n    margin-bottom: 10px;\n    border-radius: 0 !important;\n    \n}\n\n.addNewDeal button:hover{\n    background: linear-gradient(90deg,rgba(37,75,119) 0%, rgba(73,150,238) 100%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
